// react
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";

const NotificationRoot = document.getElementById("react-notifications-root");

export default class NotificationPortal extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
	};

	static defaultProps = {};

	constructor(props) {
		super(props);
		this.el = document.createElement("div");
	}

	componentDidMount() {
		if (NotificationRoot) {
			NotificationRoot.appendChild(this.el);
		}
	}

	componentWillUnmount() {
		if (NotificationRoot) {
			NotificationRoot.removeChild(this.el);
		}
	}

	render() {
		if (!this.el) {
			return null;
		}

		return ReactDOM.createPortal(
			<div className="component-notifications-container">
				<div className="notifications-list">{this.props.children}</div>
			</div>,
			this.el
		);
	}
}
